import React from 'react';

const ScrollDown: React.FC = () => {
  const handleScrollDown = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      const headerElement = document.querySelector('.header');
      const headerHeight = headerElement ? (headerElement as HTMLElement).offsetHeight : 0;
      const targetPosition = aboutSection.offsetTop - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
  };

  return (
    <div className="home__scroll">
      <a href="/about" className="home__scroll-button button--flex" onClick={handleScrollDown}>
        <div className="home__scroll-mouse">
          <div className="home__scroll-wheel"></div>
        </div>
        <span className="home__scroll-name">Scroll Down</span>
        <i className="uil uil-arrow-down home__scroll-arrow"></i>
      </a>
    </div>
  );
};

export default ScrollDown; 
